import Vue from 'vue';
import * as Sentry from '@sentry/vue';
// import '@comps/global/loading/index.js';
import router from './router/index.js';
import App from '@views/app.vue';
import './vue-init/index.js';
// import globalData from './mixins/global.js';

import store from '@/store/index.js';
import { sync } from 'vuex-router-sync';
import VueLazyload from 'vue-lazyload';

// 引入骨架屏
import { Skeleton } from '@tencent/slug-skeleton';
// 引入 slug-function-vue 插件
import { Scroll } from '@tencent/slug-ui';
import { getEnv } from '@tencent/slug-function';

import 'vue-class-component/hooks';
import '@/helper/class-component-hooks';

// 公用样式
import '@scss/_reset.scss';
import '@scss/default/common.scss';
import '@scss/default/adapt.scss';
// import '@scss/dark/dark.scss';

import lazyLoadingImg from '@img/loading.jpg';
import lazyErrorImg from '@img/components/lazyload/error.svg';
import { saveUserProfile, queryUserRoleNameNew } from '@api/usercenter';
import { tokenObj } from '@/js/tokenParams.js';

const { isMSDK, isSlugSDK } = getEnv();

// sync the router with the vuex store.
// this registers `store.state.route`

// const SentryInit = async () => {
//   try {
//     const Sentry = await import(/* webpackChunkName: "sentry" */ '@sentry/vue');
//     Sentry.init({
//       Vue,
//       dsn: 'https://f4eedf9890614ab7b5e7bc36b8bde1e1@report.url.cn/sentry/3046',  // 客户端密钥
//       release: 'my-project-name@2.3.12',
//     });
//     window.Sentry =  Sentry;
//   } catch (err) {
//     console.log(err);
//   }
// };
// SentryInit();

sync(store, router);
Skeleton.options = {
  mainColor: '#c9d7e4',
  subColor: '#E4E6ED',
  zIndex: 2,
  ra: 0,
};
Vue.directive('skeleton', Skeleton);

// Vue.use(pluginDateFilters);

Vue.use(VueLazyload, {
  loading: lazyLoadingImg,
  error: lazyErrorImg,
  // filter: {
  // toHttps(listener) {
  //   listener = listener.src && listener.src.replace(/^http:/, 'https:');
  // },
  // compressionImg(listener, options) {
  //   console.log(listener);
  //   // console.log(JSON.stringify({}));
  //   if (options.supportWebp) {
  //     listener.src += '?imageView2/w/400/format/webp';
  //   }
  // },
  // },
});

Vue.component('sui-scroll', Scroll);
// 存路由
Vue.prototype.$routeList = [];
Sentry.init({
  Vue,
  dsn: 'https://f4eedf9890614ab7b5e7bc36b8bde1e1@report.url.cn/sentry/3046',  // 客户端密钥
  release: process.env.GIT_SHA,
  logErrors: true,
});
window.Sentry = Sentry;
// window.__FAST_RENDER_DATA__
// && store.replaceState(Object.assign(store.state, JSON.parse(window.__FAST_RENDER_DATA__)));
const app = new Vue({
  // mixins: [globalData],
  router,
  store,
  render: h => h(App),
  mounted() {
    document.getElementsByTagName('body')[0].setAttribute('style', ' background: url("https://gzhcos.qq.com/gp-ingame/img/bg-all.jpg") top center no-repeat #6390c0; background-size: 100% 100%; font-size: 12px;');
  },
});

window.addEventListener('unhandledrejection', (event) => {
  console.warn(`UNHANDLED PROMISE REJECTION: ${JSON.stringify(event.reason)}`);
  Sentry.captureMessage(`UNHANDLED PROMISE REJECTION: ${JSON.stringify(event.reason)}`);
});
if (process.env.NODE_ENV === 'development') {
  Vue.config.productionTip = false;
}
if (isMSDK || isSlugSDK) {
  const { areaid: area } = tokenObj;
  let amsAcctype;
  if (area == 1) {
    amsAcctype = 'wx';
  }
  if (area == 2) {
    amsAcctype = 'qq';
  }
  queryUserRoleNameNew(area, amsAcctype).then((res) => {
    const nickname = (res.data.roles[0].roleName) || undefined;
    if (!nickname) {
      throw `获取昵称失败${JSON.stringify(res)}`;
    }
    store.commit('SET_NICKNAME', nickname);
    saveUserProfile(nickname);
  })
    .catch((err) => {
      Sentry.captureException(`获取用户昵称，保存用户信息失败, ${JSON.stringify(err)}`);
    });

  // 个保法取消授权/登陆态失效，提示信息异常。
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://tiem-cdn.qq.com/slugteam/common/js/auth.min.js'
  document.body.appendChild(script);
}

export { app, router, store };
